import useDialogState from '@/hooks/use-dialog-state'
import React, { useState } from 'react'
import { Automation } from '../schema'

type AutomationsDialogType = 'create' | 'update' | 'delete' | 'stats'

interface AutomationsContextType {
  open: AutomationsDialogType | null
  setOpen: (str: AutomationsDialogType | null) => void
  currentRow: Automation | null
  setCurrentRow: React.Dispatch<React.SetStateAction<Automation | null>>
}

const AutomationsContext = React.createContext<AutomationsContextType | null>(
  null
)

interface Props {
  children: React.ReactNode
}

export default function AutomationsProvider({ children }: Props) {
  const [open, setOpen] = useDialogState<AutomationsDialogType>(null)
  const [currentRow, setCurrentRow] = useState<Automation | null>(null)
  return (
    <AutomationsContext value={{ open, setOpen, currentRow, setCurrentRow }}>
      {children}
    </AutomationsContext>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useAutomations = () => {
  const automationsContext = React.useContext(AutomationsContext)

  if (!automationsContext) {
    throw new Error('useAutomations has to be used within <AutomationsContext>')
  }

  return automationsContext
}
